<template>
	<div>
		<div class="address_list">
			<div class="table">
				<div class="th">
					<div class="one td td1">{{$t('Receipt.consignee')}}</div>
					<div class="two td">{{$t('Receipt.country')}}</div>
					<div class="three td" style="word-wrap:break-word;">{{$t('Receipt.address')}}</div>
					<div class="four td">{{$t('Receipt.Zipcode')}}</div>
					<div class="five td">{{$t('Receipt.tel')}}</div>
					<div class="six td">{{$t('Receipt.operation')}}</div>
					<div class="last td"></div>
				</div>

				<div class="data tr" v-for="(item,index) in data" :key="index">
					<div class="one td td1">{{item.contacts}}</div>
					<div class="td two">{{item.country}}</div>
					<div class="td three" style="word-wrap:break-word;">{{item.address}}</div>
					<div class="td four">{{item.zipCode}}</div>
					<div class="td five">{{item.contactPhone}}</div>
					<div class="td six">
						<span class="edit" @click="editAddress(index)">{{$t('Receipt.modify')}}</span>
						<span @click="deleteFnc(item.addressId)">{{$t('Receipt.delete')}}</span>
					</div>
					<div class="td last">
						<div v-if="item.defaultState == 1" class="defualt">{{$t('Receipt.default')}}</div>
						<div v-if="item.defaultState == 0" class="defualt default_btn" @click="defaultFn(item)">{{$t('Receipt.setup')}}</div>
					</div>
				</div>


			</div>
			<div class="no_data" v-if="totleNum == 0">{{$t('placeorder.Nodata')}}</div>
			<div class="add">
				<div class="btn" @click="addAddress">+{{$t('Receipt.newlyadded')}}</div>
			</div>
			<div class="page">
				<el-pagination :total="5" layout="prev, pager, next"></el-pagination>
			</div>
		</div>


		<!--  模态框-->
		<ModelPop v-if="showModel" slot="model-slot">
			<div class="content-model-box">
				<div class="top-title">
					<span>{{modelType === 1 ? $t('Receipt.new') : $t('Receipt.edit')}}{{$t('Receipt.my')}}</span>
					<span class="close-btn" @click="() => showModel = false ">{{$t('Receipt.close')}}</span>
				</div>
				<div class="from-box">
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup. mechanismName}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('Receipt.input')" maxlength="50" type="text" v-model="dataGroup.mechanismName"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.contacts}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('Receipt.input')" maxlength="50" type="text" v-model="dataGroup.contacts"></el-input>
						</div>
					</div>

					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.country}}</p>
						<el-cascader v-model="dataGroup.country" :options="options" :props="{ expandTrigger: 'hover' }" @change="handleChange"
						 :placeholder="$t('Receipt.choice')"></el-cascader>
					</div>


					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.address}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('Receipt.input')" maxlength="50" type="text" v-model="dataGroup.address"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.zipCode}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('Receipt.input')" maxlength="50" type="text" v-model="dataGroup.zipCode"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"><span class="red">*</span>{{dataTitleGroup.contactPhone}}：</p>
						<div class="flex1">
							<el-input :placeholder="$t('Receipt.input')" maxlength="50" type="text" v-model="dataGroup.contactPhone"></el-input>
						</div>
					</div>
					<div class="from-col">
						<p class="from-title"></p>
						<el-button type="primary" @click="submitData">{{$t('Receipt.Submit')}}</el-button>
					</div>
				</div>
			</div>
		</ModelPop>
	</div>
</template>
<script>
	import ModelPop from "../../assembly/ModelPop";


	export default {
		components: {
			ModelPop
		},
		data() {
			return {
				token: sessionStorage.getItem("token"),
				pageNum: 1,
				pageSize: 5,
				totleNum: 20,
				data: [],
				showModel: false,
				modelType: 1,
				countries: [],
				dataGroup: {
					mechanismName: '',
					contacts: '',
					country: '',
					address: '',
					zipCode: '',
					contactPhone: ''
				},
				dataTitleGroup: {},
				value: [],
				options: []
			};
		},
		mounted() {
			this.islogin();
			this.dataTitleGroup = this.$t('Receipt.dataTitleGroup')
		},
		methods: {
			islogin() {
				if (this.token) {
					this.getMsg();
					this.getAddressMsg();

				}
			},
			getAddressMsg() {
				this.$get(`/open/linkage/tree?token=${sessionStorage.getItem('token')}`).then(res => {
					if (res.code === 0) {
						this.countries = res.data;
						let data = res.data;
						this.options = this.constData(data);
					}
				})
			},
			constData(data) {
				let result = [];
				for (let i = 0, len = data.length; i < len; i++) {
					let c = this.constData(data[i].children);
					result.push({
						value: data[i].name,
						label: data[i].name,
						[c.length <= 0 ? '' : 'children']: c
					});
				}
				return result;
			},
			//获取数据
			getMsg() {
				this.$get("/api/address/list", {
					token: this.token,
					pageNum: this.pageNum,
					pageSize: this.pageSize
				}).then(res => {
					this.data = res.data;
					this.totleNum = res.params.totalDataCounts;
				});
			},
			//删除
			deleteFnc(i) {
				this.$confirm(this.$t('Receipt.delTips'), this.$t('Receipt.Tips'), {
					confirmButtonText: this.$t('Receipt.determine'),
					cancelButtonText: this.$t('Receipt.cancel'),
					type: 'warning'
				}).then(() => {
					this.$post('/api/address/del', {
						ids: i,
						token: this.token
					}).then(res => {
						this.$message({
							type: 'success',
							message: this.$t('Receipt.delsuc')
						});
						this.getMsg()
					})

				})
			},
			//默认地址
			defaultFn(item) {
				let data = JSON.parse(JSON.stringify(item))
				this.$confirm(this.$t('Receipt.defaultTips'), this.$t('Receipt.Tips'), {
					confirmButtonText: this.$t('Receipt.determine'),
					cancelButtonText: this.$t('Receipt.cancel'),
					type: 'warning'
				}).then(() => {
					data.token = this.token;
					data.defaultState = 1;
					this.$post('/api/address/edit', data).then(res => {
						this.$message({
							type: 'success',
							message: this.$t('Receipt.modifysuc')
						});
						this.getMsg()
					})

				})


			},
			handleSizeChange(val) {
				this.pageSize = val;
			},
			handleCurrentChange(val) {
				this.pageNum = val;
			},

			editAddress(index) {
				this.showModel = true;
				this.modelType = 2;
				this.editIndex = index;
				let editData = this.data[index];
				Object.keys(this.dataGroup).forEach(item => {
					this.dataGroup[item] = editData[item] + '';
				});
				this.dataGroup.country = this.dataGroup.country.split(',')
			},

			addAddress() {
				this.showModel = true;
				this.modelType = 1;
				Object.keys(this.dataGroup).forEach(item => {
					this.dataGroup[item] = '';
				})
			},
			submitData() {
				this.$confirm(this.$t('Receipt.SubmitTips')).then(() => {
					let url = '/api/address/add';
					let datas = {
						...this.dataGroup,
						token: this.token,
					};
					datas.country = this.dataGroup.country.join(',');

					if (this.modelType === 2) {
						url = '/api/address/edit';
						datas.addressId = this.data[this.editIndex].addressId;
						this.$put(url, datas).then(res => {
							this.showModel = false;
							this.islogin();
							Object.keys(this.dataGroup).forEach(item => {
								this.dataGroup[item] = '';
							});
							this.$message({
								type: 'success',
								message: this.$t('Receipt.editsue')
							})
						});
						return;
					}



					this.$post(url, datas).then(res => {
						if (res.code === 0) {
							this.showModel = false;
							this.islogin();
							Object.keys(this.dataGroup).forEach(item => {
								this.dataGroup[item] = '';
							});
							this.$message({
								type: 'success',
								message: this.$t('Receipt.newlybuildTips')
							})
						}
					})

				}).catch(() => {
					this.$message({
						type: 'warning',
						message: '取消操作'
					})
				})
			},
			handleChange(value) {
				
			}
		},
	};
</script>
<style scoped>
	.red{
		  color: red;
	}
	.flex1{
		  flex:1;
	}
	.address_list {
		width: 1088px;
		height: 100%;
		padding: 28px 34px;
	}

	.table {
		font-size: 14px;
		box-sizing: border-box;
		width: 1088px;
		/* border: 1px solid #f5f5f5; */
	}

	.th {
		height: 40px;
		color: #333333;
		background: #f5f5f5;
		display: flex;
		line-height: 40px;
		box-sizing: border-box;
	}

	.tr {
		display: flex;
	}

	.td {
		border: 1px solid #e3e3e5;
		border-left: 0;
	}

	.td1 {
		border-left: 1px solid #e3e3e5;
	}

	div {
		white-space: normal;
		word-break: break-all;
		overflow: hidden;
	}

	.data .td {
		height: 79px;
		/* line-height: 79px; */
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.one {
		width: 86px;
	}

	.two {
		width: 154px;
	}

	.three {
		width: 227px;
		max-width: 227px;
	}

	.four {
		width: 100px;
	}

	.five {
		width: 197px;
	}

	.six {
		width: 141px;
	}

	.last {
		width: 183px;
	}

	.page {
		margin-top: 30px;
		width: 1088px;
	}

	.no_data {
		height: 40px;
		font-size: 14px;
		color: #e3e3e5;
		line-height: 40px;
		border: 1px solid #e3e3e5;
		border-top: 0;
		width: 1088px;
		box-sizing: border-box;
	}

	.add {
		width: 1088px;
		font-size: 14px;
		color: #0875cd;
		text-align: center;
		display: flex;
		align-items: center;
		height: 79px;
		border: 1px solid #e3e3e5;
		border-top: 0;
		box-sizing: border-box;
	}

	.btn {
		border: 1px solid #0875cd;
		width: 124px;
		height: 36px;
		line-height: 40px;
		margin: 0 auto;
	}

	.td span {
		padding-right: 10px;
		border-right: 1px solid #333333;
	}

	.td span:last-child {
		padding-left: 10px;
		padding-right: 10px;
		border-right: 0;
	}

	.defualt {
		width: 80px;
		height: 30px;
		background: rgba(11, 98, 166, 0.1);
		border: 1px solid rgba(8, 117, 205, 1);
		color: rgba(8, 117, 205, 1);
		box-sizing: border-box;
		line-height: 30px;
		margin: 0 auto;
	}

	.default_btn {
		border: 0;
		background: transparent;
	}

	/* model box */
	.content-model-box {
		width: 650px;
		height: 500px;
		background: #FFFFFF;
		box-shadow: 1px 1px 10px 0 rgba(255, 255, 255, 1);
		border-radius: 5px;
		margin-top: 120px;
	}

	.content-model-box>.top-title {
		height: 40px;
		line-height: 40px;
		text-align: left;
		background: rgba(243, 243, 243, 1);
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		padding-left: 20px;
		font-size: 16px;
		position: relative;
	}

	.content-model-box>.top-title>.close-btn {
		position: absolute;
		right: 10px;
		top: 0;
		cursor: pointer;
	}

	.content-model-box>.top-title>.close-btn:hover {
		color: #DF402D;
	}

	.content-model-box>.from-box {
		display: flex;
		flex-direction: column;
		max-height: calc(100% - 40px);
		overflow: auto;
		padding: 0 20px;
	}

	.content-model-box>.from-box>.from-col {
		display: flex;
		justify-content: flex-start;
		margin: 8px 0;
	}

	.content-model-box>.from-box>.from-col>.from-title {
		width: 120px !important;
		text-align: right;
		padding-right: 20px !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/memberCenter/sub/AddressList.vue